import config from "environment";
import { getRequest, postRequest, deleteRequest } from "./client";
import {
  Persona,
  CreatePersonaContract,
  UpdatePersonaContract,
  PersonaExpanded,
  AttributeType,
  EmployeeProfile,
  EvaluatePersonaConditionContract,
} from "winslow-core";

const { baseApi } = config;

export async function apiGetPersonas(
  workspaceId: string
): Promise<PersonaExpanded[] | null> {
  const fetchURL = `${baseApi}/personas/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetPersonas");
}

export async function apiCreatePersona(
  payload: CreatePersonaContract["Body"]
): Promise<{ data: Persona }> {
  const fetchURL = `${baseApi}/personas`;
  return await postRequest(fetchURL, payload, "API/apiCreatePersona");
}

export async function apiUpdatePersona(
  payload: UpdatePersonaContract["Body"]
): Promise<{ data: Persona }> {
  const fetchURL = `${baseApi}/personas/update`;
  return await postRequest(fetchURL, payload, "API/apiUpdatePersona");
}

export async function apiDeletePersona(
  personaId: string
): Promise<{ success: boolean }> {
  const fetchURL = `${baseApi}/personas/${personaId}`;
  return await deleteRequest(fetchURL, "API/apiDeletePersona");
}

export async function apiGetEmployeeAttributes(
  workspaceId: string
): Promise<Record<AttributeType, string[]> | null> {
  const fetchURL = `${baseApi}/employees/${workspaceId}/attributes`;
  return await getRequest(fetchURL, "API/apiGetEmployeeAttributes");
}

export async function apiEvaluatePersonaCondition(
  payload: EvaluatePersonaConditionContract["Body"]
): Promise<EmployeeProfile[] | null> {
  const fetchURL = `${baseApi}/personas/evaluate-conditions`;
  return await postRequest(
    fetchURL,
    payload,
    "API/apiEvaluatePersonaCondition"
  );
}
